const DocumentForwardIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33464 11.3327L8.66797 9.99935L7.33464 8.66602L8.66797 9.99935H4.66797"
      stroke="#F6FCFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6654 6.66634V9.99967C14.6654 13.333 13.332 14.6663 9.9987 14.6663H5.9987C2.66536 14.6663 1.33203 13.333 1.33203 9.99967V5.99967C1.33203 2.66634 2.66536 1.33301 5.9987 1.33301H9.33203"
      stroke="#F6FCFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6693 6.66634H12.0026C10.0026 6.66634 9.33594 5.99968 9.33594 3.99967V1.33301L14.6693 6.66634Z"
      stroke="#F6FCFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DocumentForwardIcon;
